import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="bg-white p-3 rounded-lg mb-4 inline-block">
              <img
                src="https://customer-assets.emergentagent.com/job_c5e5208d-6c87-43b5-ba57-a4994d46a238/artifacts/ea49mu95_Logo%20Email%20Signature.png"
                alt="Custom Maids RVA"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Professional cleaning services for the Greater Richmond Area. Licensed, insured, and SWaM certified.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/custommaidsrva"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#0B7CB5] transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/custommaidsrva"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#0B7CB5] transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#5CC4E8] transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#5CC4E8] transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/calculator" className="text-gray-400 hover:text-[#5CC4E8] transition-colors duration-200">
                  Estimate
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#5CC4E8] transition-colors duration-200">
                  About
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-[#5CC4E8] transition-colors duration-200">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-400 hover:text-[#5CC4E8] transition-colors duration-200">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/policies" className="text-gray-400 hover:text-[#5CC4E8] transition-colors duration-200">
                  Policies
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">Our Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/services#standard-house-cleaning" className="hover:text-[#5CC4E8] transition-colors">
                  Standard House Cleaning
                </Link>
              </li>
              <li>
                <Link to="/services#deep---initial-cleaning" className="hover:text-[#5CC4E8] transition-colors">
                  Deep Cleaning
                </Link>
              </li>
              <li>
                <Link to="/services#move-in--move-out-cleaning" className="hover:text-[#5CC4E8] transition-colors">
                  Move-In/Move-Out
                </Link>
              </li>
              <li>
                <Link to="/services#office--commercial-cleaning" className="hover:text-[#5CC4E8] transition-colors">
                  Office Cleaning
                </Link>
              </li>
              <li>
                <Link to="/services#post-construction-cleaning" className="hover:text-[#5CC4E8] transition-colors">
                  Post-Construction
                </Link>
              </li>
              <li>
                <Link to="/services#hazardous---hoarder---bio-risk-cleaning" className="hover:text-[#5CC4E8] transition-colors">
                  Hazardous/Bio-Risk Cleaning
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#5CC4E8] flex-shrink-0 mt-1" />
                <div>
                  <a href="tel:+18045837000" className="text-gray-400 hover:text-[#5CC4E8] transition-colors">
                    (804) 583-7000
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#5CC4E8] flex-shrink-0 mt-1" />
                <div>
                  <a href="mailto:custommaidsrva@gmail.com" className="text-gray-400 hover:text-[#5CC4E8] transition-colors">
                    custommaidsrva@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#5CC4E8] flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-400">Greater Richmond, VA</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Custom Maids RVA. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <span className="text-gray-400">Licensed & Insured</span>
              <span className="text-gray-400">•</span>
              <span className="text-gray-400">SWaM Certified</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};